module.exports = __webpack_public_path__ + "static/media/Sponsor_purple.da22806e.png";